<template>
  <span class="game-index" :class="[`is-${size}`, { 'is-red': parts.isRed }]" aria-hidden="true">
    <span v-if="parts.rank" class="rank">{{ parts.rank }}</span>
    <span v-if="parts.suit" class="suit">{{ parts.suit }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { splitSymbol } from '../utils/cards';

const props = defineProps({
  symbol: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'md'
  }
});

const parts = computed(() => splitSymbol(props.symbol));
</script>

<style scoped>
.game-index {
  flex: none;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--paper);
  color: var(--card-ink);
  border-radius: 5px;
  font-family: var(--font-display);
  font-weight: 700;
  line-height: 0.9;
  box-shadow:
    0 0 0 1px var(--card-line),
    0 2px 6px -2px rgba(0, 0, 0, 0.45);
}

.game-index.is-red {
  color: var(--card-red);
}

.is-md {
  width: 2.5rem;
  height: 3.25rem;
  font-size: 1.375rem;
}

.is-sm {
  width: 1.625rem;
  height: 2.125rem;
  font-size: 0.9375rem;
  border-radius: 4px;
  box-shadow: none;
  border: 1px solid var(--card-line);
}

.suit {
  font-size: 0.85em;
}

.rank:only-child,
.suit:only-child {
  font-size: 1.1em;
}
</style>
